module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "drama-banner",
    attrs: {
      "src": require("../assets/img/drama-banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "new-drama"
  }, [_c('img', {
    staticClass: "fl",
    attrs: {
      "src": require("../assets/img/drama.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("新番连载")]), _vm._v(" "), _c('div', {
    staticClass: "drama-content"
  }, _vm._l((_vm.dramaList), function(item) {
    return _c('div', {
      staticClass: "drama-item col-xs-4 fl",
      on: {
        "click": function($event) {
          _vm.dramaPlay(item.season_id, item.title)
        }
      }
    }, [_c('img', {
      staticClass: "drama-img",
      attrs: {
        "src": item.cover,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "drama-info"
    }, [_c('span', {
      staticClass: "drama-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "drama-num"
    }, [_vm._v("更新至第" + _vm._s(item.newest_ep_index) + "话")])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "drama-nav"
  }, [_c('li', [_vm._v("新番连载")]), _vm._v(" "), _c('li', [_vm._v("旧番补档")]), _vm._v(" "), _c('li', [_vm._v("国产动画")]), _vm._v(" "), _c('li', [_vm._v("动画资讯")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36525f40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/drama.vue
// module id = 103
// module chunks = 0